import React from 'react';
import EntryTable from '@lwt-helix/entry-table';
import { Col, Row } from '@lwt-helix/layout';
import PropTypes from 'prop-types';

export const OfficeDetails = ({ data }) => {
    const renderEntry = entry => {
        const value = entry.value ?? '';

        let className = 'border-top m-0';
        if (entry.isLastRow) className += ' border-bottom';

        return <>
            <Row className={className}>
                <Col>{entry.description}</Col>
                <Col className="font-weight-bold">{value}</Col>
            </Row>
        </>;
    };

    return (
        <div className="col-md-12 pd-0">
            <EntryTable
                dataLwtId={`office-details-column`}
                data={data}
                renderEntry={renderEntry}
            />
        </div>
    );
};

OfficeDetails.propTypes = {
    data: PropTypes.array,
};

